import { render, staticRenderFns } from "./YearProductionResultRowTab.vue?vue&type=template&id=4e280b26&"
import script from "./YearProductionResultRowTab.vue?vue&type=script&lang=js&"
export * from "./YearProductionResultRowTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports